import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-file-input',
	templateUrl:'./WaFileInputProPage.html',
	styles: [],
	styleUrls:['./WaFileInputProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaFileInputProPage
{
	mdContent_339 = `\`\`\`java
import com.jwebmp.webawesomepro.components.fileinput.WaFileInput;
\`\`\``;
	mdContent_340 = `\`\`\`java
new WaFileInput<>()
\`\`\``;
	mdContent_341 = `\`\`\`java
new WaFileInput<>(String label)
\`\`\``;
	mdContent_342 = `\`\`\`java
var fileInput = new WaFileInput<>();
fileInput.setAccept("image/*,.pdf");
fileInput.setMultiple(true);
fileInput.setLabel("Upload files");
\`\`\``;
	mdContent_343 = `\`\`\`java
var fileInput = new WaFileInput<>("Upload document");
fileInput.setAccept(".doc,.docx,.pdf");
fileInput.setRequired(true);
\`\`\``;
}
